export function mapValueBasedOnMaxPower(
  value: number,
  maxPower?: number | null,
): number {
  return maxPower ? Math.min(value, maxPower) : value
}
